import Vue from "vue";
import Router from "vue-router";
import Accueil from "@/components/pages/Accueil";
import Profil from "@/components/pages/Profil";
import Recherche from "@/components/pages/Recherche";
import Compte from "@/components/pages/Compte";
import Inscription from "@/components/pages/Inscription";
import Membres from "@/components/pages/Membres";
import Messagerie from "@/components/pages/Messagerie";
import Visites from "@/components/pages/Visites";
import VisitesEffectuees from "@/components/pages/VisitesEffectuees";
import Blacklist from "@/components/pages/Blacklist";
import Flash from "@/components/pages/Flash";
import FlashEnvoyes from "@/components/pages/FlashEnvoyes";
import Favoris from "@/components/pages/Favoris";
import SesFavoris from "@/components/pages/SesFavoris";
import Error404 from "@/components/error/Error404";
import ProfilSupprime from "@/components/error/ProfilSupprime";
import Pass from "@/components/pages/Pass";
import Check from "@/components/pages/Check";
import Contact from "@/components/pages/Contact";
import Serenite from "@/components/pages/Serenite";
import payment from "@/components/pages/payment";
import confirmation from "@/components/pages/confirmation";
import promo from "@/components/pages/Promo";

import Meta from "vue-meta";

Vue.use(Router);
Vue.use(Meta);

let index = "/v3/";

export default new Router({
  mode: "history",
  routes: [
    {
      path: index + "index.html",
      name: "Index",
      component: Inscription
    },
    {
      path: index,
      name: "Inscription",
      component: Inscription
    },
    {
      path: index + "accueil",
      name: "Accueil",
      component: Accueil
    },
    {
      path: index + "profil",
      name: "Profil",
      component: Profil
    },
    {
      path: index + "album",
      name: "Album",
      component: Profil
    },
    {
      path: index + "compte",
      name: "Compte",
      component: Compte
    },
    {
      path: index + "compte/:tab",
      name: "CompteTab",
      component: Compte
    },
    {
      path: index + "contact",
      name: "Contact",
      component: Contact
    },
    {
      path: index + "recherche",
      name: "Recherche",
      component: Recherche
    },
    {
      path: index + "membres",
      name: "Membres",
      component: Membres
    },
    {
      path: index + "visites",
      name: "Visites",
      component: Visites
    },
    {
      path: index + "visited",
      name: "VisitesEffectuees",
      component: VisitesEffectuees
    },
    {
      path: index + "flash",
      name: "Flash",
      component: Flash
    },
    {
      path: index + "flashed",
      name: "FlashEnvoyes",
      component: FlashEnvoyes
    },
    {
      path: index + "favoris",
      name: "Favoris",
      component: Favoris
    },
    {
      path: index + "sfavoris",
      name: "SesFavoris",
      component: SesFavoris
    },
    {
      path: index + "messagerie",
      name: "Messagerie",
      component: Messagerie
    },
    {
      path: index + "pass",
      name: "Pass",
      component: Pass
    },
    {
      path: index + "serenite",
      name: "Serenite",
      component: Serenite
    },
    {
      path: index + "bloques",
      name: "Blacklist",
      component: Blacklist
    },
    {
      path: index + "profilsuppr",
      name: "ProfilSupprime",
      component: ProfilSupprime
    },
    {
      path: index + "cheque",
      name: "Check",
      component: Check
    },
    {
      path: index + "payment",
      name: "payment",
      component: payment
    },
    {
      path: index + "confirmation",
      name: "confirmation",
      component: confirmation
    },
    {
      path: index + "admin",
      name: "Admin",
      component: () => import("@/components/admin/Admin")
    },
    {
      path: index + "admin/photos",
      name: "AdminPhotos",
      component: () => import("@/components/admin/Photos")
    },
    {
      path: index + "admin/annonces",
      name: "AdminAnnonces",
      component: () => import("@/components/admin/Annonces")
    },
    {
      path: index + "admin/restants",
      name: "AdminRestants",
      component: () => import("@/components/admin/Restants")
    },
    {
      path: index + "admin/verif",
      name: "AdminVerif",
      component: () => import("@/components/admin/Verif")
    },
    {
      path: index + "admin/promos",
      name: "AdminPromos",
      component: () => import("@/components/admin/Promos")
    },
    {
      path: index + "admin/users",
      name: "AdminUsers",
      component: () => import("@/components/admin/Users")
    },
    {
      path: index + "promo",
      name: "Promo",
      component: promo
    },
    {
      path: "*",
      name: "404",
      component: Error404
    }
  ]
});
